export const validateWebHookUrl = (url) => {
    try {
        const urlPattern = new RegExp(
            '^(https?:\\/\\/)' + // must start with http or https
            '(([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})' + // domain
            '(\\:[0-9]{1,5})?' + // optional port
            '(\\/.*)?$', // optional path/query
            'i'
        );

        if (!urlPattern.test(url)) {
            return { valid: false, message: 'Please enter a valid Webhook URL (must start with http or https)' };
        }

        return { valid: true, message: null }
    } catch (error) {

    }
}